import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { DeleteIcon, DuplicateIcon, FreezeTable, MoreIcon } from '@sketchnote/icons';
import { Divider, IconTextBtn } from '@sketchnote/shared-components';
import cn from 'classnames';
import * as React from 'react';

const { useState } = React;

export interface MoreOptionsProps {
  onDuplicate: () => void;
  onDelete: () => void;
  onFreeze: () => void;
}

export const MoreOptions = ({ onDelete, onDuplicate, onFreeze }: MoreOptionsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = (value?: boolean) => () => {
    setIsOpen(value ?? !isOpen);
  };

  return (
    <Popover
      placement="bottom"
      isOpen={isOpen}
      onOpen={toggleMenu(true)}
      onClose={toggleMenu(false)}
      modifiers={[{ name: 'eventListeners', options: { scroll: isOpen } }]}
    >
      <PopoverTrigger>
        <button
          className={cn('flex items-center', { 'text-gray-999': isOpen, 'text-gray-500': !isOpen })}
        >
          <MoreIcon wrapperClass="" />
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <div className="flex flex-col p-6 rounded-lg bg-white shadow-mdl3 text-gray-999 min-w-144">
            <IconTextBtn
              className="px-8 py-10 hover:bg-gray-100 rounded-sm"
              onClick={onDuplicate}
              iconLeft={<DuplicateIcon className="mr-6 text-gray-500" />}
            >
              Duplicate
            </IconTextBtn>
            <IconTextBtn
              className="px-8 py-10 hover:bg-gray-100 rounded-sm"
              onClick={onDelete}
              iconLeft={<DeleteIcon className="mr-6 text-gray-500" />}
            >
              Delete
            </IconTextBtn>
            <Divider style={{ marginBottom: '0.5rem', marginTop: '0.5rem' }} />
            <IconTextBtn
              className="px-8 py-10 hover:bg-gray-100 rounded-sm"
              onClick={onFreeze}
              iconLeft={<FreezeTable className="mr-6 text-gray-500" />}
            >
              Freeze
            </IconTextBtn>
          </div>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
